// TR-480: cấu hình CTA "1:1 Strategy Call" (book lịch tư vấn qua Lark scheduler nhúng iframe).

// Ngưỡng eligibility: shop có số order tháng dương lịch liền trước >= ngưỡng này mới thấy CTA.
// Nguồn dữ liệu: response getUserPlan field `orderCountLastMonth` (backend expose từ shop_general, TR-470).
export const STRATEGY_CALL_MIN_ORDERS = 300;

// URL Lark scheduler nhúng trong modal (spec TR-480 §2.3 F2). Merchant chọn lịch trực tiếp trong iframe.
export const LARK_SCHEDULER_URL = 'https://xipatcorp.sg.larksuite.com/scheduler/2b25924b50c8d62a';
